import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';


@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.css']
})
export class VendorListComponent implements OnInit, AfterViewInit {

  searchKeyword = "";
  userData: any = [];
  displayedColumns: string[] = ['srNo', 'userName', 'email', 'createdAt', 'emailVerified', 'action'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  permissions: any;
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private toastrMsgService: ToastrService) {

  }

  ngOnInit(): void {
    this.fetchUsers();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }

  getStatusClass(status: string) {
    switch (status) {
      case 'Verified': return 'bg-green-500 text-white px-2 rounded-full';
      case 'Rejected': return 'bg-red-500 text-white px-2 rounded-full';
      case 'Pending': return 'bg-yellow-400 text-white px-2 rounded-full';
      default: return 'bg-gray-300 text-black px-2 rounded-full';
    }
  }

  updateStatus(newStatus: string, user: any) {
    // Update logic here
  }

  playPauseHandler(event: any, item: any) {
    // Toggle logic here
  }


  fetchUsers() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getUsers(params).subscribe({
      next: (res: any) => {
        console.log(res);

        this.dataSource.data = res;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }
  deleteUser(userId: string) {
    const confirmDelete = confirm("Are you sure you want to delete this User?");
    if (!confirmDelete) {
      return;
    }
    this.apiService.deleteUserById(userId).subscribe({
      next: (res: any) => {
        this.toastrMsgService.success('User deleted successfully');
        this.fetchUsers(); // Refresh the data after deletion
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error('Failed to delete user');
      }
    });
  }
}